export function getApiHost() {
  if (process.env.NODE_ENV === "development") {
    return "https://www.bean77.xyz/";
  }
  const host = window.location.host;
  const prefix = window.location.href.match(/^https?:\/\//)[0];
  return prefix + host;
}



// WEBPACK FOOTER //
// ./src/lib/getApiHost.js